export const FETCH__LIST__USER__SUCCESS = "FETCH__LIST__USER__SUCCESS";
export const FETCH__LIST__USER__FAIL = "FETCH__LIST__USER__FAIL";

export const FETCH__USER__SUCCESS = "FETCH__USER__SUCCESS";
export const FETCH__USER__FAIL = "FETCH__USER__FAIL"

// export const FETCH__EDIT__USER__SUCCESS = "FETCH__ADD__USER__SUCCESS"
// export const FETCH__ADD__USER__FAIL = "FETCH__ADD__USER__FAIL"

export const FETCH__EDIT__USER__SUCCESS = "FETCH__EDIT__EDIT__SUCCESS"
export const FETCH__EDIT__USER__FAIL = "FETCH__EDIT__USER__FAIL"

